module.exports = __webpack_public_path__ + "img/pjt-logo.d08fecd0.png";